import * as Yup from "yup";
export const EnvironmentSchema = Yup.object({
    NODE_ENV: Yup.string().required(),
    DEBUG: Yup.bool().required(),
    isProduction: Yup.bool().required(),
    isDevelopment: Yup.bool().required(),
});
export function getEnvironmentConfig(env) {
    const NODE_ENV = env.NODE_ENV;
    const DEBUG = env.REACT_APP_DEBUG === "true";
    const isProduction = env.NODE_ENV === "production";
    const isDevelopment = env.NODE_ENV === "development";
    return {
        DEBUG,
        isProduction,
        isDevelopment,
        NODE_ENV,
    };
}
//# sourceMappingURL=environment.js.map